@import '../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../constants/spacing.module.less';

.header-wrapper {
  background-color: var(--default--background-color--1);
  color: var(--default--text-color--18);
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 40px;
  padding: @space-8 @space-16;
  font-size: 14px;
  line-height: 24px;
  border-bottom: 1px solid var(--default--border-color--12);
  gap: @space-8;
}

.title {
  display: flex;
  align-items: center;
  gap: @space-8;
}

.close-wrapper {
  display: flex;
  gap: @space-16;
  align-items: center;
}
